/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_One_SecondInputs */

const en_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back one second in the video`)
};

const fr_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reculer d'une seconde dans la video`)
};

const de_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spulen Sie im Video eine Sekunde zurück.`)
};

const it_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna indietro di un secondo nel video`)
};

const ru_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернитесь на одну секунду назад в видео.`)
};

const es_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceda un segundo en el vídeo`)
};

const zh_cn2_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频倒退一秒。`)
};

const ja_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画を1秒前に戻す`)
};

const hi_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में एक सेकंड पीछे जाइए।`)
};

const pt_pt2_shortcut_keys_desc_reverse_one_second = /** @type {(inputs: Shortcut_Keys_Desc_Reverse_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte um segundo no vídeo.`)
};

/**
* | output |
* | --- |
* | "Go back one second in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_One_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_one_second = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_One_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_One_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "de") return de_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "it") return it_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "es") return es_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_reverse_one_second(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_reverse_one_second(inputs)
	return en_shortcut_keys_desc_reverse_one_second(inputs)
});